

























import { FromStore } from "@abaco/web-common/src/app";
import { BaseUser } from "@abaco/web-common/src/BaseUser";
import { plainToClass } from "class-transformer";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Vue } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../../index";
import { Subject } from "../../models/Subject";

@Component
export default class Header extends Vue {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @FromStore(MODULE_ID) user?: BaseUser;
    @FromStore(MODULE_ID) isSignleSubject!: boolean;
    @FromStore({ module: MODULE_ID, prop: "currentSubject" }) subject!: Subject | null;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

    get breadCrumbs(): { text: string; title?: string; link?: string }[] {
        if (this.$route.meta?.breadCrumb) {
            if (typeof this.$route.meta.breadCrumb === "function") {
                let ret = this.$route.meta.breadCrumb({ ...this.$route.params }, this.isSignleSubject) as {
                    text: string;
                    title?: string;
                    link?: string;
                }[];
                const index = ret.findIndex(e => e.text === "subject-list");
                ret = ret.map(({ text, link }) => ({ text: this.i18n(text).toString(), link }));
                if (this.currentSubject) {
                    if (index === -1) {
                        ret.unshift({
                            text: `<span class="hidden lg:inline">${this.currentSubject.full_name} - </span>${this.currentSubject.fiscal_code}`,
                            title: this.currentSubject.toString()
                        });
                    } else if (ret.length > 1) {
                        ret.splice(index + 1, 0, {
                            text: `<span class="hidden lg:inline">${this.currentSubject.full_name} - </span>${this.currentSubject.fiscal_code}`,
                            title: this.currentSubject.toString()
                        });
                    }
                }

                return ret;
            }
        }
        return [];
    }

    logout() {
        this.maltaModule.tokensResources.logout();
        this.$router.go(0);
    }

    get currentSubject(): Subject {
        if (this.subject instanceof Subject) return this.subject;
        return plainToClass(Subject, this.subject);
    }

    changeSubject() {
        this.$router.push({
            name: "subjectList"
        });
    }

    newProject() {
        this.$router.push({
            name: "project-proposal-new"
        });
    }
}
